import React from 'react';

import customerProductStyles from "assets/jss/material-dashboard-pro-react/components/customerProductStyles.jsx";

import { formatNumber } from 'helpers/CurrencyHelpers';

import Card from "components/Card/Card.jsx";
import CardBody from "components/Card/CardBody.jsx";
import { withStyles, ButtonBase } from '@material-ui/core';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronLeft } from '@fortawesome/pro-solid-svg-icons';
import ProductImage from '../../components/Image/ProductImage';
import NavPills from "components/NavPills/NavPills.jsx";
import GeneralTab from './ViewCustomerStatsTabs/GeneralTab';
import VolumesTab from './ViewCustomerStatsTabs/VolumesTab';
import GPTab from './ViewCustomerStatsTabs/GPTab';

class CustomerProductItem extends React.Component {

    state = {
        open: false,
        hasOpened: false
    }

    render() {
        const { classes } = this.props;
        return (
            <div style={{ position: 'relative' }}>
                <Card Component={ButtonBase} className={classes.container} onClick={() => { this.setState({ open: !this.state.open, hasOpened: true }) }}>
                    <CardBody className={classes.content}>
                        <div className={classes.icon}>
                            <ProductImage style={{ height: 110, width: 110 }} image={this.props.image} />
                        </div>
                        <div className={classes.label}>
                            {this.props.name}
                        </div>
                        <div className={classes.count}>
                            {this.props.count === 0 ? " " : formatNumber(this.props.count)}
                        </div>
                        <div className={classes.caret + (this.state.open ? " open" : "")}>
                            <FontAwesomeIcon icon={faChevronLeft} size="3x" />
                        </div>
                    </CardBody>
                </Card>
                <Card className={classes.stats + (this.state.open ? " open" : "")} style={{ height: (this.state.open ? (window.innerHeight + 100) : 0) }}>
                    {
                        this.state.hasOpened ?
                            <NavPills
                                tabsStyles={{ marginTop: 0 }}
                                color="primary"
                                tabs={[
                                    {
                                        tabButton: "General",
                                        tabContent: <GeneralTab {...this.props} />
                                    },
                                    {
                                        tabButton: "Volumes",
                                        tabContent: <VolumesTab {...this.props} />
                                    },
                                    {
                                        tabButton: "Gross Profit",
                                        tabContent: <GPTab {...this.props} />
                                    }
                                ]}
                            />
                            : null
                    }
                </Card>
            </div>
        );
    }
}

export default withStyles(customerProductStyles)(CustomerProductItem);
